import { render } from "./NewManifesto.vue?vue&type=template&id=ce715954"
import script from "./NewManifesto.vue?vue&type=script&lang=js"
export * from "./NewManifesto.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__